import cx from 'classnames';
import {Typography} from '~library/atoms/Typography';
import {DiamondIcon} from '~library/svg/DiamondIcon';

import './LabelPremium.sass';

type LabelPremiumProps = {
  className?: string;
};

export const LabelPremium = ({className}: LabelPremiumProps) => {
  return (
    <div className={cx('label-premium', className)}>
      <DiamondIcon className="label-premium__icon" />
      <Typography variant="paragraph3" color="roseWebText">
        Premium
      </Typography>
    </div>
  );
};
